// Module
var code = "<frozen-registration ng-if=$ctrl.user user=$ctrl.user close=$ctrl.close()></frozen-registration>";
// Exports
module.exports = code;